import React, { Component } from "react";
import { getPropertyСonstant } from "./services/geozoneHelper";
import styles from "./geozoneInfoControl.module.scss";

class GeozoneInfoProperty extends Component {
  render() {
    const { property } = this.props;
    const data = getPropertyСonstant(property);
    if (data === null) return null;

    return (
      <div key={property.code} className={styles.propertyItem}>
        <div className={styles.propertyTitle}>{data.title}: </div>
        <div className={styles.propertyValue}>{data.value}</div>
      </div>
    );
  }
}

export default GeozoneInfoProperty;
